export default {
    afterInit: function(component){
        component.enableSubmit = false;
        var questionMap = component.questionMap;
        var hideThese = [22,23,24,25];
        setTimeout(function(){
            for(let i=0; i<hideThese.length; i++){
                var qid = hideThese[i];
                var question = questionMap[qid];
                if(question.display_triggers.length==0){
                    question.display = false;
                }
            }
        },3000)
    }
}